import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ApexForm as ApexForm$1 } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { useBlockEnvironment } from '../../components/BlockList/BlockEnvironment/BlockEnvironmentProvider.js';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var BlockApexForm = function BlockApexForm(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var _useBlockEnvironment = useBlockEnvironment(),
    _useBlockEnvironment$ = _useBlockEnvironment.environment,
    environment = _useBlockEnvironment$ === void 0 ? 'prod' : _useBlockEnvironment$;
  var defaultValues = getDefaultApexFieldValues(innerBlocks);
  var endpoint = environment === 'prod' ? 'https://zg-api.com/interested-party/submit' : 'https://zg-api.test.zillow.net/interested-party/submit';
  return /*#__PURE__*/React.createElement(ApexForm$1, _extends({
    key: index,
    defaultValues: defaultValues
  }, attrs, {
    endpoint: endpoint
  }), generateBlockList({
    blocks: innerBlocks
  }));
};
function getDefaultApexFieldValues(innerBlocks) {
  var defaultValues = {};

  // getDefaultApexFieldValuesHelper will mutate defaultValues
  getDefaultApexFieldValuesHelper(innerBlocks, defaultValues);
  return defaultValues;
}

// This mutates defaultValues as it recurses through innerBlocks.
function getDefaultApexFieldValuesHelper(innerBlocks, defaultValues) {
  innerBlocks.forEach(function (innerBlock) {
    if (innerBlock.blockName === 'constellation/apex-field') {
      if (innerBlock.attrs.defaultValue) {
        // eslint-disable-next-line no-param-reassign
        defaultValues[innerBlock.attrs.formData] = innerBlock.attrs.defaultValue;
      }
    }
    getDefaultApexFieldValuesHelper(innerBlock.innerBlocks, defaultValues);
  });
}
BlockApexForm.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  id: PropTypes.string,
  attrs: PropTypes.shape({
    businessLine: PropTypes.string.isRequired,
    warmLeadSource: PropTypes.string.isRequired
  })
} : {};
BlockApexForm.defaultProps = {
  id: undefined,
  index: undefined,
  attrs: {
    businessLine: '',
    warmLeadSource: ''
  }
};
var ApexForm = BlockApexForm;

export { ApexForm as default };
